import { isValidEmail } from 'core-components/library/validation'

export const isForwarderEmailValid = async (email: string) => (email ? isValidEmail(email) : '')
